<template>
  <div class="sku-header">
    <div class="name-wrapper">
      <!-- 名称前标签 -->
      <div v-if="skuAttrTags.length > 0" class="attr-wrapper">
        <Tag
          v-for="(tag, index) in skuAttrTags"
          :key="'tag' + index"
          :has-border="!!tag.frameColor"
          :has-background="!!tag.backgroundColor"
          :primary-color="tag.textColor"
          :secondary-color="tag.frameColor"
          :corner-radius="tag.cornerRadius"
          :bg-color="tag.backgroundColor"
          :use-trans-scale="false"
          :font-size="tag.textSize"
          :bold="!!tag.bold"
          no-bottom-margin
          :padding-left-right="3"
        >
          {{ tag.tag }}
        </Tag>
      </div>
      <!-- 名称 包规-->
      <span class="name">{{ skuName }}{{ skuFormat }}</span>
    </div>
    <div v-if="introduceTags.length > 0" class="sku-introduce">
      <template v-for="(tag, index) in introduceTags">
        <Tag
          :key="'tag' + index"
          :has-border="!!tag.frameColor"
          :has-background="!!tag.backgroundColor"
          :primary-color="tag.textColor"
          :secondary-color="tag.frameColor"
          :corner-radius="tag.cornerRadius"
          :bg-color="tag.backgroundColor"
          :has-margin="false"
          :use-trans-scale="false"
          :font-size="tag.textSize"
          :bold="!!tag.bold"
          no-bottom-margin
        >
          {{ tag.tag }}
        </Tag>
        <span
          v-if="index !== introduceTags.length - 1"
          :key="'line' + index"
          class="introduce-line"
          >|</span
        >
      </template>
    </div>
    <!-- <div v-if="descTag" class="sku-desc-new">{{ descTag }}</div> -->
    <template v-if="descTags.length > 0">
      <div class="sku-desc-new">
        <span
          v-for="tag in descTags"
          :key="'tag' + tag.tagType"
          class="tag-item"
          :style="{
            color: tag.textColor
          }"
          >{{ descTrim(tag.tag) }}</span
        >
      </div>
    </template>
  </div>
</template>

<script>
import Tag from '@/common/widgets/good_tag'

export default {
  components: {
    Tag
  },
  props: {
    sku: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {
    skuAttrTags() {
      return this.sku?.skuIntroduce?.skuAttrTags || []
      // return [
      //   {
      //     tagType: 574,
      //     tag: '收藏',
      //     frameColor: '#FF8802',
      //     backgroundColor: '#FF8802',
      //     textColor: '#FFFFFF',
      //     cornerRadius: 4,
      //     textSize: 12
      //   },
      //   {
      //     tagType: 574,
      //     tag: '收藏',
      //     frameColor: '#FF8802',
      //     backgroundColor: '#FF8802',
      //     textColor: '#FFFFFF',
      //     cornerRadius: 4,
      //     textSize: 12
      //   }
      // ]
    },
    skuName() {
      return this.sku?.skuBase?.skuName || ''
    },
    skuFormat() {
      return this.sku?.skuFormats?.skuFormat || ''
    },
    introduceTags() {
      const introduceTags = this.sku?.skuIntroduce?.introduceTags || []
      const feedbackTags = this.sku?.skuIntroduce?.feedbackTags || []
      return [...(feedbackTags || []), ...(introduceTags || [])]
    },
    descTags() {
      return this.sku?.skuIntroduce?.descTags || []
    },
    descTag() {
      const descTags = this.sku?.skuIntroduce?.descTags || []
      const tag = descTags?.[0]?.tag || ''
      if (tag) {
        return this.descTrim(tag)
      } else {
        return null
      }
    }
  },
  created() {},
  methods: {
    descTrim(desc = '') {
      return desc?.replace(/\s+/g, '')
    }
  }
}
</script>

<style lang="scss" scoped>
.sku-header {
  // .name-wrapper {
  //   @include flex-row-center-column-normal;
  //   .attr-wrapper {
  //     display: flex;

  //     flex: none;
  //   }
  //   .name {
  //     @include text(16px, #262626, true);
  //     @include text-overflow-ellipsis-single;
  //   }
  // }
  .name-wrapper {
    @include text-overflow-ellipsis-multiple;
    .attr-wrapper {
      display: inline-flex;
      vertical-align: middle;
    }
    .name {
      @include text(16px, #262626, true);
      vertical-align: top;
      line-height: 18px;
    }
  }
  .sku-introduce {
    position: relative;

    margin-top: 0.08rem;

    overflow: hidden;
    @include flex-row;
    .introduce-line {
      margin-right: 4px;

      font-size: 0.24rem;
      color: #d9d9d9;
    }
    &::after {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;

      width: 0.26rem;

      background-image: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        #fff 100%
      );

      content: '';
    }
  }
  .sku-desc-new {
    height: 16px;
    font-size: 12px;
    color: #8c8c8c;
    line-height: 16px;
    margin-top: 4px;
    @include text-overflow-ellipsis;
    .tag-item {
      margin-right: 4px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
